<div class="conferencing-subscription-indicator" *ngIf="showDebug$ | async as showDebug">
  <mat-icon
    *ngIf="conferencingSubscription$ | async as conferencingSubscription"
    svgIcon="cm:phone-call"
    [ngClass]="conferencingSubscription.connected === true ? 'success' : 'error'"
  ></mat-icon>
</div>
